import { render, staticRenderFns } from "./BeFooter.vue?vue&type=template&id=ddb22eb2&scoped=true&"
import script from "./BeFooter.vue?vue&type=script&lang=js&"
export * from "./BeFooter.vue?vue&type=script&lang=js&"
import style0 from "./BeFooter.vue?vue&type=style&index=0&id=ddb22eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb22eb2",
  null
  
)

export default component.exports